import { removeTags } from '../../../helpers';
import * as Styled from './IdeaCard.styled';

interface IdeaBodyProps {
  readonly ideaId: string;
  readonly text: string;
  readonly hasAccess: boolean;
}

export const IdeaBody = ({ ideaId, text, hasAccess }: IdeaBodyProps) => {
  const bodyText = removeTags(text || '').slice(0, 500);

  return (
    <Styled.IdeaBody aria-hidden="true">
      {hasAccess ? (
        <a href={`/post/${ideaId}`} target="_top" tabIndex={-1}>
          {bodyText}
        </a>
      ) : (
        <span>{bodyText}</span>
      )}
    </Styled.IdeaBody>
  );
};
